"use client";

import { useState } from 'react';
import { useNavigate } from 'react-router-dom';

import cx from 'classnames'

import styles from "./styles.module.scss";

import Button from "../lms/ButtonComponent";

import { BUTTON_VARIANTS } from "../lms/constant";

import ArrowIcon from '../../../assets/images/arrow-right-icon.svg';
import InfoIcon from '../../../assets/images/info-icon.svg';
import StarIcon from '../../../assets/images/star-icon.svg';
import LockIcon from '../../../assets/images/lock-icon.svg';
import DocIcon from '../../../assets/images/doc-icon.svg';

import { useGetTeacherFinalAssessmentDetails } from './queries';
// import StatusBanner from './StatusBanner';

import { FINAL_ASSESSMENT_ALLOWED } from '../../../utils/cookiesmanager';

// import ScoreProgress from './ScoreProgress';
import Shimmer from '../lms/ShimmerComponent';

import { useGetTranslatedText } from '../lms/queries';
import { getTranslatedText } from '../../../utils/getTranslatedText';
import ScoreProgress from '../finalAssessment/ScoreProgress';
import { downloadCertificateApiCall } from './utils.api';
import { toast } from 'react-toastify';

const TeacherFinalAssessment = () => {
  const userDetails = JSON.parse(localStorage.getItem('user') || '{}');

  const teacherId = localStorage.getItem('id');
  const [loading , setLoading] = useState(false)

  console.log(teacherId , 'teacherId')

  const navigate = useNavigate();

  const {data , isLoading , isFetching} = useGetTeacherFinalAssessmentDetails(teacherId);

  const {response} = data?.data || {};

  console.log(data , 'datadatadata')

  const {
    minimumPassingScore,
    questionCount,
    userAssessmentScore,
    startAssessment,
    tryAgainAssessment,
    assessmentLockedStatus
  } = response || {};

  console.log(assessmentLockedStatus,'assessmentLockedStatusassessmentLockedStatus')
  
  const handleAssessmentRedirection = () => {
    sessionStorage.setItem(FINAL_ASSESSMENT_ALLOWED,"true");
    navigate('/user/final-assessment-question')
  }

  const languageId = localStorage.getItem("l_id") || 1;
  
  const { data: translatedTextResponse } = useGetTranslatedText(languageId);
  
  const { data: translatedText = [] } = translatedTextResponse || {};

  const handleDownloadCertificate = async () => {
      const userId = localStorage.getItem('id');
       
        setLoading(true)
        try {
          const response = await downloadCertificateApiCall(userId);
    
          const blob = new Blob([response?.data], {
            type: "application/pdf",
          });
          const url = URL.createObjectURL(blob);
    
          const a = document.createElement("a");
          a.href = url;
          a.download = `Course - certificate.pdf`;
          a.click();
    
          URL.revokeObjectURL(url);
        } catch (error) {
          toast.error("Internal server error");
          console.error(error);
        } finally {
          setLoading(false);
        }
  }  

  const assessmentScore = Number(userAssessmentScore?.replace('%',''));
  const passingScoreValue = Number(minimumPassingScore?.replace('%',''));

  return (
    <>
    {
      isLoading || isFetching
      ?
      <Shimmer width='90%' height='100vh' style={{margin:'10px auto'}} borderRadius='16px' />
      :
      <div className={styles.wrapper}>
      <div className={styles['final-assessment']}>
        <div className={styles.headerRow}>
          <div className={styles.header}>
            <div className={styles.icon}><img src={DocIcon} alt='' /></div>
            <h3 className={styles['final-assessment-text']}>
              {
                getTranslatedText(
                translatedText,
                "final_assessment",
                "Final Assessment",
              )
              }
              </h3>
          </div> 
          {
          assessmentScore >= passingScoreValue ?
          <span className={styles['pass-tag']}>
            {
                getTranslatedText(
                translatedText,
                "key_pass",
                "Pass",
              )
              }
           </span>
          :
          assessmentLockedStatus === 0 ?
           <span className={styles.lockTag}><img className={styles.img} src={LockIcon} alt=''  />
            {
              getTranslatedText(
                translatedText,
                "locked_label",
                "Locked",
              )
            }
           </span>
           :null
          }
          
        </div>

  {
  assessmentScore >= passingScoreValue
  ?
  <div>
  <ScoreProgress score={userAssessmentScore} />
  <Button
    label={loading ? 'downloading...' : 
      getTranslatedText(
                translatedText,
                "btn_download_certificate",
               `Download Certificate`,
      )
      }
    buttonVariant={BUTTON_VARIANTS.SECONDARY}
    className={styles['download-certificate']}
    onClick={handleDownloadCertificate}
    disabled={loading}
  />
  </div>
  :
  
  <>
    <div className={styles.grid}>
          <div className={styles.statBox}>
            <p className={styles['question-text']}>
              {
                getTranslatedText(
                translatedText,
                "questions",
                "Questions",
              )
              }
              </p>
            <h2 className={styles.count}>{questionCount}</h2>
          </div>

          <div className={styles.statBox}>
            <p className={styles['question-text']}>
              {
                getTranslatedText(
                translatedText,
                "passing_score",
                "Passing Score",
              )
              }
              </p>
            <h2 className={styles.count}>{minimumPassingScore}</h2>
          </div>
        </div>
    {   startAssessment === 0 ? 
        <p className={styles.points}><img src={StarIcon} alt="" />
        {
          getTranslatedText(
                translatedText,
                "pass_to_earn_certificate",
                "Pass to earn certificate",
          )
        }
        </p>
        :
        null
        }
        {
            assessmentLockedStatus === 0 ?
            <div className={cx(styles.infoBox,styles.info)}>
           <img className={styles.img} src={InfoIcon} alt='' /> 
           <div className={styles.content}>
            <span className={styles.locked}>
              {
                getTranslatedText(
                translatedText,
                "locked_label",
                "Unlock conditions :",
              )
              }
              </span> 
            <ol className={styles.unlockList}>
            <li>
              {
                getTranslatedText(
                translatedText,
                "teacher_assessment_unlocks",
                "This assessment unlocks after 3 months in the course.",
              )
              }
              </li>    
            <li>
              {
                getTranslatedText(
                translatedText,
                "teacher_executive_plan",
                "execute intervention plan and score at least 25% progress or mark all your levels on it.",
              )
              }
              </li>        
            </ol> 
        </div>
        </div>
        :null
        }
      <Button
            label=
            {
              tryAgainAssessment === 1 ?  
              getTranslatedText(
                translatedText,
                "btn_retry_assessment",
                'Re-Try Assessment',
              ) : 
              getTranslatedText(
                translatedText,
                "key_start_assessment",
                'Start Assessment',
              ) 
            }
            buttonVariant={BUTTON_VARIANTS.PRIMARY}
            disabled={startAssessment === 0 && tryAgainAssessment === 0}
            className={styles['upload-btn']}
            // className={styles["exit-button"]}
            endIcon={<img src={ArrowIcon} alt="upload-icon" />}
            onClick={handleAssessmentRedirection}
      />
  </>
}

    </div>
    </div>
    }
    </>
  );
};

export default TeacherFinalAssessment;
